(function() {
  const STOCK_PARAM = 'filter.v.availability';

  function getModeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('stock') === 'all') return 'all';
    if (params.get(STOCK_PARAM) === '0') return 'sold-out';
    return 'in-stock';
  }

  function normalize(text) {
    return String(text || '').trim().toLowerCase();
  }

  function getScope(element) {
    return element?.closest('.shopify-section, main, body') || document;
  }

  function getCards(scope) {
    const root = scope && scope.querySelector ? scope : document;
    return Array.from(root.querySelectorAll('#product-grid > .grid__item')).filter((item) => item.querySelector('.collection-product-card'));
  }

  function getQuery(scope) {
    const input = scope.querySelector('[data-page-product-search]') || document.querySelector('[data-page-product-search]');
    return normalize(input?.value);
  }

  function getProductType(scope) {
    const select = scope.querySelector('[data-page-product-type-filter]') || document.querySelector('[data-page-product-type-filter]');
    return normalize(select?.value);
  }

  function syncProductTypeSelectFromUrl(root = document) {
    const params = new URLSearchParams(window.location.search);
    root.querySelectorAll('[data-page-product-type-filter]').forEach((select) => {
      const param = select.dataset.filterParam || select.getAttribute('name');
      if (!param || !params.has(param)) return;
      select.value = params.get(param) || '';
    });
  }

  function navigateProductTypeFilter(select) {
    if (!select || select.dataset.serverFilter !== 'true') return;
    const param = select.dataset.filterParam || select.getAttribute('name');
    if (!param) return;
    const url = new URL(window.location.href);
    if (select.value) {
      url.searchParams.set(param, select.value);
    } else {
      url.searchParams.delete(param);
    }
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function getStock(item) {
    const card = item.querySelector('.collection-product-card');
    const raw = normalize(item.dataset.productStock || card?.dataset.productStock);
    if (raw.includes('sold') || raw.includes('out')) return 'sold-out';
    return 'in-stock';
  }

  function matchesQuery(item, query) {
    if (!query) return true;
    const card = item.querySelector('.collection-product-card');
    const haystack = [
      card?.dataset.sortTitle,
      card?.querySelector('.collection-product-title')?.textContent,
      card?.querySelector('.collection-variant-meta')?.textContent,
      card?.querySelector('.collection-variant-pill-list')?.textContent
    ].map(normalize).join(' ');
    return haystack.includes(query);
  }

  function matchesProductType(item, productType) {
    if (!productType) return true;
    const card = item.querySelector('.collection-product-card');
    return normalize(item.dataset.productType || card?.dataset.productType) === productType;
  }

  function setActiveStock(scope, mode) {
    const root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('.collection-stock-filter__link[data-stock-mode]').forEach((link) => {
      const active = (link.dataset.stockMode || 'in-stock') === mode;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  function updateUrlMode(mode) {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('stock');
    url.searchParams.delete(STOCK_PARAM);
    if (mode === 'all') url.searchParams.set('stock', 'all');
    if (mode === 'sold-out') url.searchParams.set(STOCK_PARAM, '0');
    if (mode === 'in-stock') url.searchParams.set(STOCK_PARAM, '1');
    window.history.replaceState({}, '', url.toString());
  }

  function applyGridFilters(scope = document, explicitMode) {
    const mode = explicitMode || getModeFromUrl();
    const query = getQuery(scope);
    const productType = getProductType(scope);
    setActiveStock(scope, mode);

    getCards(scope).forEach((item) => {
      const stock = getStock(item);
      const stockMatch = mode === 'all' || stock === mode;
      item.hidden = !(stockMatch && matchesQuery(item, query) && matchesProductType(item, productType));
    });
  }

  function buildSuggestions(input) {
    const scope = getScope(input);
    const wrap = input.closest('.collection-page-search, .search-page-inline-tools') || input.parentElement;
    if (!wrap) return;

    let suggestions = wrap.querySelector('.page-search-suggestions');
    if (!suggestions) {
      suggestions = document.createElement('div');
      suggestions.className = 'page-search-suggestions';
      suggestions.hidden = true;
      wrap.appendChild(suggestions);
    }

    const query = normalize(input.value);
    suggestions.innerHTML = '';
    if (query.length < 2) {
      suggestions.hidden = true;
      return;
    }

    const matches = getCards(scope)
      .map((item) => {
        const card = item.querySelector('.collection-product-card');
        return { item, title: card?.dataset.sortTitle || card?.querySelector('.collection-product-title')?.textContent || '' };
      })
      .filter((entry) => normalize(entry.title).includes(query))
      .slice(0, 8);

    if (!matches.length) {
      const empty = document.createElement('div');
      empty.className = 'page-search-suggestion page-search-suggestion--empty';
      empty.textContent = 'No products found on this page';
      suggestions.appendChild(empty);
      suggestions.hidden = false;
      return;
    }

    matches.forEach((entry) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'page-search-suggestion';
      button.textContent = entry.title;
      button.addEventListener('click', () => {
        input.value = entry.title;
        applyGridFilters(scope);
        suggestions.hidden = true;
        focusSearchMatch(entry.item);
      });
      suggestions.appendChild(button);
    });
    suggestions.hidden = false;
  }

  function getVisibleMatches(scope, query) {
    const productType = getProductType(scope);
    return getCards(scope).filter((item) => {
      const stock = getStock(item);
      const mode = getModeFromUrl();
      return (mode === 'all' || stock === mode) && matchesQuery(item, query || getQuery(scope)) && matchesProductType(item, productType);
    });
  }

  function focusSearchMatch(item) {
    if (!item) return;
    item.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const card = item.querySelector('.collection-product-card') || item;
    card.classList.add('is-page-search-match');
    window.setTimeout(() => card.classList.remove('is-page-search-match'), 1400);
  }

  function runPageSearch(input) {
    const scope = getScope(input);
    applyGridFilters(scope);
    buildSuggestions(input);
    const firstMatch = getVisibleMatches(scope, getQuery(scope)).find((item) => !item.hidden);
    if (firstMatch) focusSearchMatch(firstMatch);
  }

  function bindStockFilters(root = document) {
    root.querySelectorAll('.collection-stock-filter__link[data-stock-mode]').forEach((link) => {
      if (link.dataset.sevenRealmsPhase4Bound === 'true') return;
      link.dataset.sevenRealmsPhase4Bound = 'true';
      // Stock filters use Shopify-generated URLs so pagination, counts, and
      // availability filters stay consistent across every collection.
    });
  }

  function bindPageSearch(root = document) {
    if (window.SevenRealmsPageLocalSearchOwnedByCards) return;

    root.querySelectorAll('[data-page-product-search]').forEach((input) => {
      if (input.dataset.sevenRealmsPhase4Bound === 'true') return;
      input.dataset.sevenRealmsPhase4Bound = 'true';
      input.setAttribute('autocomplete', 'off');
      input.addEventListener('input', () => {
        const scope = getScope(input);
        applyGridFilters(scope);
        buildSuggestions(input);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          runPageSearch(input);
        } else if (event.key === 'Escape') {
          const suggestions = input.closest('.collection-page-search, .search-page-inline-tools')?.querySelector('.page-search-suggestions');
          if (suggestions) suggestions.hidden = true;
        }
      });
      input.addEventListener('focus', () => buildSuggestions(input));
    });

    root.querySelectorAll('[data-page-product-search-submit]').forEach((button) => {
      if (button.dataset.sevenRealmsPhase4SearchButtonBound === 'true') return;
      button.dataset.sevenRealmsPhase4SearchButtonBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const input = button.closest('.collection-page-search, .search-page-inline-tools')?.querySelector('[data-page-product-search]');
        if (!input) return;
        runPageSearch(input);
        input.focus({ preventScroll: true });
      });
    });

    root.querySelectorAll('[data-page-product-type-filter]').forEach((select) => {
      if (select.dataset.sevenRealmsPhase4TypeBound === 'true') return;
      select.dataset.sevenRealmsPhase4TypeBound = 'true';
      select.addEventListener('change', () => {
        applyGridFilters(getScope(select));
        navigateProductTypeFilter(select);
      });
    });
  }

  function bindVariantPillScrollGuard(root = document) {
    root.querySelectorAll('.collection-variant-pill').forEach((pill) => {
      if (pill.dataset.sevenRealmsScrollGuardBound === 'true') return;
      pill.dataset.sevenRealmsScrollGuardBound = 'true';
      pill.addEventListener('click', () => {
        const x = window.scrollX;
        const y = window.scrollY;
        window.requestAnimationFrame(() => window.scrollTo(x, y));
        window.setTimeout(() => window.scrollTo(x, y), 75);
      }, true);
    });
  }

  function bindCatalogFilterLaunchers(root = document) {
    root.querySelectorAll('[data-sr-filter-launcher]').forEach((button) => {
      if (button.dataset.sevenRealmsFilterBound === 'true') return;
      button.dataset.sevenRealmsFilterBound = 'true';
      button.addEventListener('click', () => {
        const scope = getScope(button);
        const nativeTrigger = scope.querySelector('#main-collection-filters summary.mobile-facets__open-wrapper')
          || document.querySelector('#main-collection-filters summary.mobile-facets__open-wrapper');
        nativeTrigger?.click();
      });
    });
  }

  function init(root = document) {
    bindStockFilters(root);
    bindPageSearch(root);
    bindVariantPillScrollGuard(root);
    bindCatalogFilterLaunchers(root);
    syncProductTypeSelectFromUrl(root);
    applyGridFilters(root);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('collectionProductsLoaded', (event) => init(event.detail?.container || document));
})();
